import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Lookup } from 'src/common/Common.Type'
import { useGet } from 'src/hooks/useGet'
import { GetParentHospitalConfiguration, GetUsersPharmacies } from 'src/requests/Shared'
import { infoToaster } from 'src/utils'
import DropDown from '../DropDown'
import { privilegesContext } from 'src/context/privileges'
import { hospitalConigurationType } from 'src/types/ContextsType/Privileges.Type'
import { Context } from 'src/context'
import { userPharmacyLookup } from 'src/types/hospital'

const PharmDropDown = () => {
    const { setHospitalConfiguration } = useContext(privilegesContext)
    const { setPharmaciesLookup } = useContext(Context)
    const [sOption, setSOption] = useState<Lookup & { hospitalId: number } | null>(null)

    const { state, pathname } = useLocation()

    const { data: pharmaLookup = [] } = useGet<userPharmacyLookup[]>({
        API: GetUsersPharmacies,
        depArr: [],
        params: [],
        isNotValid: false,
        defaultValue: [],
        needSpinner: true,
    })

    const { data: parentHospitalConfiguration = [] } = useGet<hospitalConigurationType[]>({
        API: GetParentHospitalConfiguration,
        depArr: [],
        params: [sOption?.hospitalId],
        isNotValid: !sOption?.value,
        defaultValue: [],
        needSpinner: true
    })

    const navigate = useNavigate()
    const handleSelect = (option: userPharmacyLookup | null) => {
        navigate(pathname, { state: { pharmName: option } })
        sessionStorage.setItem("optionId", option?.value ? String(option?.value) : "0")
        sessionStorage.setItem("hopsitalId", option?.hospitalId ? String(option?.hospitalId) : "0")
        if (option) {
            infoToaster('success-pharma-alert', { pharmName: option?.label })
        } else {
            infoToaster('pharmacy-choice-cancelled')
        }
        setSOption(option)
    }

    useEffect(() => {
        setPharmaciesLookup(pharmaLookup)
    }, [pharmaLookup])

    useEffect(() => {
        if (parentHospitalConfiguration.length) {
            sessionStorage.setItem("hospitalCofigurations", JSON.stringify(parentHospitalConfiguration))
            setHospitalConfiguration(parentHospitalConfiguration)
        }
    }, [parentHospitalConfiguration])

    return (
        <DropDown
            val={sOption || state?.pharmName}
            setVal={(value: userPharmacyLookup | null) => handleSelect(value)}
            options={pharmaLookup}
            label=""
            placeholder={'pharmacy'}
            disabled={!pharmaLookup.length}
        />
    )
}

export default PharmDropDown